// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountGetPrescribersDefaultResponse {
    static getAttributeTypeMap() {
        return AccountGetPrescribersDefaultResponse.attributeTypeMap;
    }
}
AccountGetPrescribersDefaultResponse.discriminator = undefined;
AccountGetPrescribersDefaultResponse.additionalProperties = false;
AccountGetPrescribersDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
];
//# sourceMappingURL=accountGetPrescribersDefaultResponse.js.map